import React from 'react'

import Carousel from './carousel'

var TEXTS = [
  {
    de:
      '1400 Jahre haben Christen und Muslime im Nahen Osten ihr Leben geteilt. Nicht immer ganz friedvoll, aber als Nachbarn. Wir glauben daran, dass diese Nach\u00ADbarschaft durch gegen\u00ADseitigen Respekt erneuert werden kann.'
  },
  {
    ar:
      'منذ 1400 سنة يتقاسم مسيحيو ومسلمو الشرق الأوسط الحياة معا، وعلى الرغم من إن هذا التجاور لم يكن في بعض الأحيان سلمي، إلا أننا نؤمن أنه من خلال الاحترام المتبادل يمكن إحياء هذا التعايش مرة أخرى'
  },
  {
    en:
      'For the past 1400 years Muslims and Christians have shared their life in the Near East – not always peaceful but as neighbours. We believe that this trust can once again be revived.'
  },
  {
    sp:
      'O kommt im schlichten Hemde<br/>Zum buntgemischten Mahl!<br/>Ihr sollt, und seid ihr fremde,<br/>Nicht fremd hier seyn zumal.<br/>Ich bring euch als die meinen<br/>So möget ihr erscheinen<br/>Im deutschen Gastversammlungsmahl.<br/>(Friedrich Rückert)'
  },
  {
    fr:
      'Durant 1400 ans, musulmans et chrétiens ont partagé leur vie au Proche-Orient – pas toujours de façon pacifique, mais en tant que voisins. Nous sommes convaincus que ce respect mutuel peut être à nouveau rétabli.'
  },
  {
    sw:
      'I 1400 år har kristna och muslimer levt tillsammans i Mellanöstern. Inte alltid i fred, men ändå som grannar. Vi tror att detta grannskap kan uppstå på nytt byggt på ömsesidig respekt.'
  }
]

var INTERVAL = 9000

export default function Landing(props) {
  return (
    <section id="subintro">
      <Carousel
        slides={TEXTS}
        interval={INTERVAL}
        className="subintro"
        slideRTL={false}
        selectLanguage={props.selectLanguage}
      />
    </section>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/subintro.js
 **/